import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';

const FilterBar = ({
  searchQuery,
  onSearchChange,
  selectedIndustry,
  onIndustryChange,
  selectedTechnology,
  onTechnologyChange,
  selectedType,
  onTypeChange,
  selectedComplexity,
  onComplexityChange,
  onClearFilters,
  industryOptions,
  technologyOptions,
  typeOptions,
  complexityOptions,
  activeFiltersCount
}) => {
  return (
    <div className="bg-card rounded-xl border border-border p-4 md:p-6 mb-6 md:mb-8">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg md:text-xl font-bold font-heading text-foreground">
          Filter Projects
        </h2>
        {activeFiltersCount > 0 && (
          <button
            onClick={onClearFilters}
            className="flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-muted transition-all duration-300"
          >
            <Icon name="X" size={16} />
            <span>Clear All ({activeFiltersCount})</span>
          </button>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
        <Select
          label="Industry"
          placeholder="All Industries"
          options={industryOptions}
          value={selectedIndustry}
          onChange={onIndustryChange}
          clearable
        />

        <Select
          label="Technology"
          placeholder="All Technologies"
          options={technologyOptions}
          value={selectedTechnology}
          onChange={onTechnologyChange}
          searchable
          clearable
        />

        <Select
          label="Project Type"
          placeholder="All Types"
          options={typeOptions}
          value={selectedType}
          onChange={onTypeChange}
          clearable
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Select
          label="Complexity"
          placeholder="All Levels"
          options={complexityOptions}
          value={selectedComplexity}
          onChange={onComplexityChange}
          clearable
        />

        <Input
          label="Search Projects"
          type="search"
          placeholder="Search by name, description, or technology..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e?.target?.value)}
        />
      </div>
    </div>
  );
};

export default FilterBar;